







































































































import Vue from 'vue'
import { mapGetters } from 'vuex'
import { getUserInfo } from '@/utils/auth'
import { WarehouseAreaServiceProxy } from '@/service-proxies/app-v2/warehouse.service-proxies'
import { MasterlinkTenantServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { CodeRuleServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'

const wasp = new WarehouseAreaServiceProxy()
const mtsp = new MasterlinkTenantServiceProxy()
const crsp = new CodeRuleServiceProxy()

export default Vue.extend({
  name: 'Tree.vue',
  props: ['select'],
  data() {
    return {
      treeList: [],
      treeData: [],
      expandedKeys: ['0'],
      selectedKeys: ['0'],
      showGroupAction: false, // 是否展示分组的下拉菜单
      actionType: '1', // 操作类型：1 新增子目录，2 编辑
      replaceFields: {
        key: 'id'
      },
      detail: {} as any, // 库区详情
      tenantName: '',
      selectedTreeItem: {} as any,

      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      areaList: [],
      disabled: false
    }
  },
  computed: {
    ...mapGetters(['buttons'])
  },
  watch: {
    buttons: {
      handler(val) {
        // 当3个按钮均不显示时隐藏下拉框
        let btn1 = 'page_business_create_sub_dir'
        let btn2 = 'page_business_edit_reservoirn'
        let btn3 = 'page_business_delete_reservoir'
        this.showGroupAction = !!(val.includes(btn1) || val.includes(btn2) || val.includes(btn3))
      },
      immediate: true,
      deep: true
    },
    visible: {
      handler(val) {
        if (val) {
          this.loading = false
          if (this.actionType === '1') { // 新增
            this.form = this.$form.createForm(this)
          } else { // 编辑
            this.form = this.$form.createForm(this, {
              mapPropsToFields: () => {
                return {
                  code: this.$form.createFormField({
                    value: this.detail.code
                  }),
                  name: this.$form.createFormField({
                    value: this.detail.name
                  }),
                  remark: this.$form.createFormField({
                    value: this.detail.remark
                  })
                }
              }
            })
          }
        }
      },
      immediate: true
    }
  },
  async created() {
    const qr = await mtsp.queryRole(getUserInfo().tenant_id)
    const { data: { tenantName } } = qr
    this.tenantName = tenantName
    this.treeData.push({ name: this.tenantName, id: '0', scopedSlots: { title: 'custom' }, children: [] })
    this.getTreeData()
    this.getCodeRules()
  },
  methods: {
    getTreeData() {
      this.treeList = []
      this.treeData[0].children = []
      wasp.listWarehouseArea('').then(res => {
        if (res && res.length) {
          this.treeList = res
          this.treeData[0].children = this.handleTreeData(res)
        }
        if (this.treeData[0].children.length) { // 默认展开一级节点
          this.selectedKeys = [this.treeData[0].children[0].id]
          // this.selectedKeys = ['0']
          this.expandedKeys = ['0']
          this.select(this.selectedKeys[0])
        }
      })
    },
    handleTreeData(data: any) {
      data.map((item: any) => {
        Object.assign(item, { scopedSlots: { title: 'custom' } })
      })
      return data
    },
    onExpand(expandedKeys: any) {
      this.expandedKeys = expandedKeys
    },
    onSelect(selectedKeys: any) {
      if(selectedKeys && selectedKeys.length === 0){
        return
      }
      this.selectedKeys = selectedKeys
      // console.log('selected', selectedKeys)
      if (this.selectedKeys.length) {
        this.select(this.selectedKeys[0])
      }
    },
    handleAction(key: any, item: any) {
      console.log(key, item)
      this.detail = {}
      if (key === '1') { // 新建子目录
        this.actionType = '1'
        this.visible = true
      } else if (key === '2') { // 编辑
        this.actionType = '2'
        this.getDetail(item.id)
      } else { // 删除
        this.deleteWarehouseArea(item.id)
      }
    },
    async getDetail(id: string) {
      this.detail = await wasp.getWarehouseArea(id)
      this.visible = true
    },
    async deleteWarehouseArea(id: string) {
      try {
        await wasp.deleteWarehouseArea(id)
        this.$message.success(this.$t('page_resource_pool_success'))
        this.getTreeData()
      } catch (e) {
      }
    },
    handleOk() {
      this.loading = true
      this.form.validateFieldsAndScroll(async (err: any, values: any) => {
        if (err) {
          this.loading = false
          return
        }

        let params = {
          ...values
        }
        // console.log('params:', params)
        try {
          if (this.actionType === '1') { // 新增
            await wasp.createWarehouseArea(params)
          } else { // 编辑
            await wasp.updateWarehouseArea(params, this.selectedKeys[0])
          }
          this.handleCancel(true)
        } catch (e) {
        }
        this.loading = false
      })
    },
    handleCancel(reload?: boolean) {
      this.visible = false
      this.disabled = false
      if (reload === true) {
        this.getTreeData()
      }
    },
    async getCodeRules(){
    const res = await crsp.list('AreaObject')
    this.areaList = res
  },
  handleSelectChange(val) {
    
    
    if(val) {
      this.disabled = true
      this.form.setFieldsValue({['code']:''})
    }else {
      this.disabled = false
    }
    }
  }
})
